import React, { useEffect, useState } from "react";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle,
} from "../ui/dialog";
import { listPastPayPeriods } from "../../lib/api";

export default function PastPeriodsDialog({ open, onClose }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        listPastPayPeriods()
            .then(setRows)
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, []);
    return (
        <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
            <DialogContent
                onOpenAutoFocus={(e) => e.preventDefault()}
                className="bg-[#131A2F] border border-[#2A3655] text-white max-w-3xl max-h-[85vh] overflow-auto"
                data-testid="past-periods-dialog"
            >
                <DialogHeader>
                    <DialogTitle className="text-white">Past pay periods</DialogTitle>
                </DialogHeader>
                {loading && <div className="text-slate-400 text-sm">Loading…</div>}
                {!loading && rows.length === 0 && <div className="text-slate-400 text-sm">No reports yet.</div>}
                <div className="space-y-3">
                    {rows.map((p) => (
                        <details key={p.id} className="bg-[#0A1128] border border-[#2A3655] rounded-sm" data-testid={`past-period-${p.id}`}>
                            <summary className="px-3 py-2 cursor-pointer flex flex-wrap justify-between text-sm gap-2">
                                <span className="font-mono">{p.period_start} → {p.period_end}</span>
                                <span className="flex items-center gap-3">
                                    <span className="text-[#00A3FF] font-bold">{(p.employees || []).reduce((a, b) => a + (b.total_hours || 0), 0).toFixed(1)}h</span>
                                    {(p.grand_total_pay > 0) && (
                                        <span className="text-emerald-300 font-bold">${Number(p.grand_total_pay).toFixed(2)}</span>
                                    )}
                                </span>
                            </summary>
                            <div className="px-3 py-2 border-t border-[#2A3655] space-y-2">
                                {(p.employees || []).map((e) => (
                                    <div key={e.employee_id} className="text-xs text-slate-300">
                                        <div className="font-bold text-white">
                                            {e.name} — {e.total_hours}h
                                            {e.total_pay != null && <span className="text-emerald-300"> · ${Number(e.total_pay).toFixed(2)}</span>}
                                            {e.hourly_rate != null && <span className="text-slate-500"> @ ${Number(e.hourly_rate).toFixed(2)}/h</span>}
                                        </div>
                                        <ul className="ml-4 text-slate-400">
                                            {(e.rows || []).map((r, idx) => (
                                                <li key={idx}>{r.date} {(r.start_time || "").slice(11, 16)}–{(r.end_time || "").slice(11, 16)} ({r.hours}h) {r.job_address && `@ ${r.job_address}`}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </details>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
